import { useRef, useEffect, useState } from "react";
import { Input } from "../../Shared/Input";

import "./index.css";

function DownloadFileWidgetContent({
  file_name,
  onSetWidgets,
}) {
  const ref = useRef();
  const [_, setAttachmentFile] = useState();
  const [fileName, setFileName] = useState();

  useEffect(() => {
    if (file_name && file_name.length > 0) {
      setFileName(file_name);
    }
  }, []);

  function onChange() {
    const { current } = ref;
    if (current.files && current.files.length > 0) {
      const file = current.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const res = reader.result;
        onSetWidgets("attachment_file", res);
        setAttachmentFile(res);
        onSetWidgets("file_name", file.name);
        setFileName(file.name);
      }
      reader.readAsDataURL(file);
    }
  }

  return (
    <div className="DownloadWidgetContent">
      <Input
        type="text"
        label="file name"
        value={fileName}
        disabled={true}
        onChange={() => {}}
      />
      <div className="DownloadWidgetUpload">
        <label className="Btn Btn--lime">
          <input
            ref={ref}
            type="file"
            style={{ display: "none" }}
            accept=".xls,.xlsx,.pdf,.doc,.docx"
            onChange={onChange}
          />
          <span className="BtnText">Upload</span>
        </label>
      </div>
    </div>
  )
}

export default DownloadFileWidgetContent;
